import { useEffect, useState } from "react";
// import AdditionalInfo from "./AdditionalInfoParts/AdditionalInfo";
import QualityScore from "./AdditionalInfoParts/QualityScore";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { ActionItemsEndPointLogic } from "../../../../../logic/AssetManagement/ActionItems/actionItemsEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import CommentsAndFiles from '../../../../Discussion/CommentsAndFiles';

const ActionItemAdditionalInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [isFetchedData, setIsFetchedData] = useState(false);
  const selectedActionItemShareuid = searchParams.get(
    "actionItemSharedUid"
  ) as any; //-- get selected action item shared_uid from url query param
  const oauthTokenHeader = useSelector(selectUserToken) as any;

  //-- Fetch Single Information about Action Item which is selected
  const fetchSingleActionItemData = async () => {
    if (!oauthTokenHeader || !selectedActionItemShareuid) return;
    try {
      setLoading(true);
      await ActionItemsEndPointLogic.getSingleActionItemData(
        oauthTokenHeader,
        selectedActionItemShareuid,
        dispatch,
        navigate,
        location
      );
      setIsFetchedData(true);
    } catch (error) {
      // eslint-disable-next-line
      console.error("Error fetching action item data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (oauthTokenHeader && selectedActionItemShareuid) {
      setIsFetchedData(false);
      fetchSingleActionItemData();
    } else {
      navigate(`/assets/overview/action_items`); // Redirect to the Action Items List
    }
    // eslint-disable-next-line
  }, [oauthTokenHeader, selectedActionItemShareuid]);

  useEffect(() => {
    ActionItemsEndPointLogic.getAllUserList(oauthTokenHeader);
  }, [oauthTokenHeader]);

  return (
    <>
      {loading && !isFetchedData ? (
        <SimpleBackdrop />
      ) : (
        <>
          {isFetchedData && (
            <>
              <QualityScore />
              {/* <AdditionalInfo /> */}
              <CommentsAndFiles
                objectType="tasks"
                referenceModule="Overview Action Items"
                moduleType="actionItems"
                objectSharedUid={selectedActionItemShareuid}
                postCommentTrackID="307"
                reactionTrackID="457"
                uploadFileTrackID="467"
                downloadFileTrackID="468"
                previewFileTrackID="516"
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default ActionItemAdditionalInfo;
